import * as yup from 'yup';

import { CronJobName } from '../types';

export const restCleanupCronJobsSchema = yup.object({
  cutoffDate: yup.string(),
  batchSize: yup.number(),
  max: yup.number(),
  maxTime: yup.number()
});

export const cleanupCronJobsSchema = (jobName?: CronJobName) =>
  yup.object({
    config: yup.object().shape({
      count: yup.number(),
      ...(jobName !== 'bpm-execution-cleanup'
        ? restCleanupCronJobsSchema.fields
        : {})
    })
  });
